var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTopUpBalanceIcon = function SvgTopUpBalanceIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.9986 6.66852C38.7413 6.67325 29.0935 14.7173 27.0645 25.7902C36.7542 20.4878 48.9078 24.0444 54.2103 33.7341C57.4838 39.7162 57.4838 46.9539 54.2103 52.936C66.8813 50.6149 75.2715 38.4614 72.9503 25.7904C70.9207 14.7106 61.2628 6.66425 49.9986 6.66852Z",
    fill: "#D5D5FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3346 73.3333C32.5394 73.3333 40.0013 65.8714 40.0013 56.6667C40.0013 47.4619 32.5394 40 23.3346 40C14.1299 40 6.66797 47.4619 6.66797 56.6667C6.66797 65.8714 14.1299 73.3333 23.3346 73.3333Z",
    fill: "#6563FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6637 23.3315C26.3857 23.3325 17.7816 31.1234 16.7637 41.3509C25.2163 37.7192 35.0126 41.6274 38.6443 50.0801C40.448 54.2784 40.448 59.0332 38.6443 63.2315C49.6352 62.1386 57.6593 52.3427 56.5664 41.3518C55.5493 31.1227 46.9432 23.3305 36.6637 23.3315Z",
    fill: "#A1A1ED"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTopUpBalanceIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/topUpBalanceIcon.40b908e0.svg";
export { ForwardRef as ReactComponent };